import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2L2 22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 7L2 22h15V7z"
})), 'NetworkCellOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NetworkCellOutlined.js
// module id = 5012
// module chunks = 2